export class Stack<T> {
    private readonly items: Array<T> = [];

    push(item: T) {
        this.items.unshift(item);
    }

    pop() {
        const item = this.items.shift();
        return item;
    }

    peek() {
        return this.items[0];
    }

    get size() {
        return this.items.length;
    }
}
